import React, { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";

const FixRentalModal = () => {
    const [isOpen, setIsOpen] = useState(true);
    const navigate = useNavigate();

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleGetStarted = () => {
        handleClose(); // Close the modal
        navigate("/home"); // Navigate to the home/enquiry page
    };

    return (
        <Modal
            open={isOpen}
            onClose={handleClose}
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div style={styles.modalContainer}>
                <div style={styles.iconContainer}>
                    <img
                        src="https://img.icons8.com/color/96/rocket.png"
                        alt="Rocket Icon"
                        style={styles.icon}
                    />
                </div>
                <h2 style={styles.title}>Start Today</h2>
                <p style={styles.description}>
                    Welcome to FixRental! Start exploring our machine rental
                    services now. Click below to proceed.
                </p>
                <a href="#enquiry">
                <button style={styles.button} onClick={handleGetStarted}>
                    Enquire Now
                </button>
                </a>
                <p onClick={()=>setIsOpen(false)} style={styles.link}>
                    No thanks.
                </p>
            </div>
        </Modal>
    );
};

// Styles
const styles = {
    modalContainer: {
        background: "white",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        textAlign: "center",
        maxWidth: "400px",
        width: "90%",
    },
    iconContainer: {
        marginBottom: "15px",
    },
    icon: {
        width: "60px",
        height: "60px",
    },
    title: {
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    description: {
        fontSize: "16px",
        color: "#555",
        marginBottom: "20px",
    },
    button: {
        backgroundColor: "#f04f24",
        color: "#fff",
        border: "none",
        padding: "10px 20px",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold",
    },
    link: {
        marginTop: "15px",
        fontSize: "14px",
        color: "#007bff",
        cursor: "pointer",
    },
};

export default FixRentalModal;
